/**
 * @file
 * Form field behaviors for layerone.
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.layeroneForms = {
    attach: function (context, settings) {

      // Forms
      $('.clear-textfield', context).click(function() {
        let input = $(this).parent().prev('input');
        input.val('').focus();
        $(this).parent().removeClass('d-inline-block').addClass('d-none');
      });

      $('.form-type-textfield .form-control', context).keyup(function() {
        let value = $(this).val();
        if (value !== '') {
          // $(this).next('.close-me-container').removeClass('d-none').addClass('d-inline-block');
        } else {
          $(this).next('.close-me-container').removeClass('d-inline-block').addClass('d-none');
        }
      });

      $('.form-type-textfield .form-control', context).each(function() {
        let value = $(this).val();
        if (value !== '') {
          // $(this).next('.close-me-container').removeClass('d-none').addClass('d-inline-block');
        } else {
          $(this).next('.close-me-container').removeClass('d-inline-block').addClass('d-none');
        }
      });
      // End forms

      // Focus rings: base/_focus.scss (:focus-visible) - no script.

    }
  };

})(jQuery, Drupal);
